import * as actions from 'client/actions'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

export default function useUpdateSeoProperty() {
  const dispatch = useDispatch()

  return useCallback(
    property => value => dispatch(actions.updateSeoProperty(property, value)),
    [],
  )
}
